const STORAGE_KEY = 'pos_api_url';
const DEFAULT_URL = 'http://localhost:9000';

const ApiConfig = {
    getBaseUrl() {
        return localStorage.getItem(STORAGE_KEY) || DEFAULT_URL;
    },
    setBaseUrl(url) {
        if (url) {
            localStorage.setItem(STORAGE_KEY, url);
        }
    }
};

export default ApiConfig;
